<template>
  <div>
    <div class="mask_menu" v-if="isShow" @click="close"></div>
    <div class="perMenu">
      <div class="name" @click="checkMenu">
        <img src="./images/menu.png" alt="" v-if="menuName === '菜单'"/>
        <img src="./images/open.png" alt="" v-else />
        {{menuName}}
      </div>
      <div v-if="isShow" class="main">
        <a href="javascript:;" @click="jumpPersonInfo">
          <img src="./images/person.png" alt="">
          <span>个人中心</span>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import common from "../../assets/js/common";

export default {
  data() {
    return {
      origin: process.env,
      menuName: "菜单",
      isShow: false,
      entListPopShow: false,
      isUser: false
    };
  },
  methods: {
    close() {
      this.isShow = false;
      this.entListPopShow = false;
    },
    checkMenu() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.menuName = "收起";
      } else {
        this.menuName = "菜单";
      }
    },
    jumpPersonInfo() {
      const typeId = common.getCookie("typeId");
      let retUrl = "/mob/memberInfo/list";
      if (typeId) {
        retUrl = `${retUrl}?typeId=${typeId}`;
      }
      window.location.href = retUrl;
    }
  }
};
</script>
